import intersectionObserver from 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Spinner from 'vue-spinner-component/src/Spinner.vue'
import './registerServiceWorker'

Vue.use(intersectionObserver)

Vue.component('Spinner', Spinner)

Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
